module.exports = __webpack_public_path__ + "fce49ef054fc314310406547add1718e.png";